import React, { useContext } from 'react';

import './About.css';
import { ThemeContext } from '../../contexts/ThemeContext';
import { aboutData } from '../../data/aboutData'
import { GrCloudComputer } from "react-icons/gr";



function About() {

    const { theme } = useContext(ThemeContext);
    return (
        <div className="about" id="about" style={{backgroundColor: theme.secondary}}>
            <div className="line-styling">
              <div className="style-circle" style={{backgroundColor: theme.primary}}></div>
              <div className="style-circle" style={{backgroundColor: theme.primary}}></div>
              <div className="style-line" style={{backgroundColor: theme.primary}}></div>
            </div>
            <div className="about-body">
                <div className="about-description">
                    <h2 style={{color: theme.primary}}>{aboutData.title}</h2>
                    <p style={{color:theme.tertiary80}}>{aboutData.description1}<br/><br/>{aboutData.description2}<br></br><br></br>{aboutData.description3}</p>
                    <div  style={{alignItems:"center", textAlign: "center"}}>
                    <img className="cloud" src="https://www.svgrepo.com/show/240415/programmer.svg" alt=""></img>
                    <img className="cloud" src="https://www.svgrepo.com/show/12083/cloud-computing.svg" alt=""></img>
                    <img className="cloud" src="https://www.svgrepo.com/show/295412/development-web-development.svg" alt=""></img>
                    <img className="cloud" src="https://www.svgrepo.com/show/24405/guitar.svg" alt=""></img>
                    <img className="cloud" src="https://www.svgrepo.com/show/302599/controller.svg" alt=""></img>
                    </div>
                </div>
                <div className="about-img">
                    <img 
                        src={aboutData.image === 1 ? theme.aboutimg1 : theme.aboutimg2}  
                        alt="" 
                    />
                </div>
                
            </div>
            
        </div>

    )
}

export default About
